
      import GameController from "../src/ui/gameController.js";
      import { renderLeaderboard } from "../src/ui/leaderboard.js";

      function initAll() {
        const app = document.getElementById("app");
        const leaderboardRoot = document.getElementById("leaderboard-root");
        if (leaderboardRoot) renderLeaderboard(leaderboardRoot);
        new GameController(app);
      }

      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initAll);
      } else {
        initAll();
      }
    